import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { navigate("/admin", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        setUser(data.user);
        window.history.replaceState(null, "", "/admin/dashboard");
        navigate("/admin/dashboard", { replace: true, state: { user: data.user } });
      } catch {
        setError(true);
        setTimeout(() => navigate("/admin", { replace: true }), 1500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex flex-col items-center justify-center py-40 text-brand-navy">
      <Loader2 className="h-8 w-8 animate-spin" />
      <p className="mt-4 font-semibold">{error ? "Sign-in failed, redirecting..." : "Signing you in..."}</p>
    </div>
  );
}
